'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var keyMaster = require('key-master');

var getPropertyValuesInOrder = function getPropertyValuesInOrder(o) {
	return Object.getOwnPropertyNames(o).map(function (key) {
		return o[key];
	});
};
var assertType = function assertType(name, value, expectedType) {
	var actualType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	if (actualType !== expectedType) {
		throw new Error('Expected ' + name + ' to be ' + expectedType + ' but it was ' + actualType);
	}
};

module.exports = function createEmitter() {
	var emitter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object.create(null);

	var eventsToListeners = keyMaster(function () {
		return Object.create(null);
	});

	emitter.on = function (event, listener) {
		assertType('event', event, 'string');
		assertType('listener', listener, 'function');

		var id = Math.random().toString();
		var listeners = eventsToListeners.get(event);
		listeners[id] = listener;

		return function () {
			delete listeners[id];
		};
	};

	emitter.once = function (event, listener) {
		assertType('event', event, 'string');
		assertType('listener', listener, 'function');

		var unsubscribe = emitter.on(event, function () {
			listener.apply(undefined, arguments);
			unsubscribe();
		});

		return unsubscribe;
	};

	emitter.emit = function (event) {
		for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
			args[_key - 1] = arguments[_key];
		}

		assertType('event', event, 'string');

		var listeners = eventsToListeners.get(event);
		getPropertyValuesInOrder(listeners).forEach(function (listener) {
			return listener.apply(undefined, args);
		});
	};

	return emitter;
};
